import { mainSlice } from "../../../stateManagement/redux";
import { useDispatch} from "react-redux";



export const RigOptions = (props: { onClick: any }) => {

    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(mainSlice.actions.setProjectOnClick())
    }

    return (
        <div className='wrap-main__menu'>
            <div className='wrap-main__menu__container_header'>
                <img src="/assets/icons/rigs.svg" alt='Well Whisper' height={40} width={40} />
                <div>Operaciones de Taladro</div>
                <div className='wrap-main__menu__close_icon' onClick={() => onClick()}>
                    <img src="/assets/icons/arrow-left.svg" alt='Well Whisper' height={8} width={8} />
                </div>
            </div>
            <div className='wrap-main__menu__container_buttons'>
                {/* <ButtonBig icon={Dashboard} text='Dashboard' iconHeight={30} />
                <ButtonBig icon={Chat} text='Ali' iconHeight={30} />
                <ButtonBig icon={History} text='Historial Actividades' iconHeight={30} />
                <ButtonBig icon={Upload} text='Subidas de Archivos' iconHeight={30} /> */}
            </div>
        </div>
    )
}